var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'bingo')?_c('bingo'):(_vm.type === 'wheelOfFortune')?_c('wheel-of-fortune'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }